import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import { getElements } from '../elements'
import type { Manager } from '../manager'

export const applyApprovedProposalToCytoscape = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.approveProposal.observe().pipe(
      // We get the new data
      rxjsUtils.latestFrom(
        () =>
          feature.selectors.getOrgChartData({ orgChartId: 'current' })
            .asObservable,
      ),
      rxjs.map(data => {
        const cy = manager.getInstance({ orgChartId: 'current' })
        if (!data || !cy) {
          // Can't do anything if the data or cytoscape instance are undefined
          return
        }
        // Replace all elements with the new data
        cy.remove('*')
        cy.add(getElements(data))
        manager.resetLayout({ orgChartId: 'current' })
      }),
      rxjs.ignoreElements(),
    ),
)
